<template>
  <div>
    {{ getPlan }}
    <form class="mt-2" id="form-modal">
      <div class="form-group">
        <label class="label-form"
          >Price<span style="color: red">*</span>:</label
        >
        <input class="form-control" type="number" v-model="amount" />
      </div>

      <div class="form-footer text-right">
        <button
          v-if="flag"
          type="button"
          class="btn btn-secondary btn-sm"
          data-dismiss="modal"
        >
          Close
        </button>
        <button
          v-else
          type="button"
          class="btn btn-secondary btn-sm"
          backdrop="static"
          keyboard="false"
          @click="cancel"
        >
          <font-awesome-icon
            v-if="isMiniLoading"
            icon="spinner"
            style="
              animation: spin 2s linear infinite;
              float: right;
              margin-left: 5px;
              margin-top: 3px;
            "
          />
          Cancel
        </button>

        <button
          v-if="flag"
          type="button"
          class="btn btn-primary btn-sm ml-1"
          @click="savePrice"
        >
          <font-awesome-icon
            v-if="isMiniLoading"
            icon="spinner"
            style="
              animation: spin 2s linear infinite;
              float: right;
              margin-left: 5px;
              margin-top: 3px;
            "
          />
          Save
        </button>
      </div>
    </form>
    <div class="pt-4 border-top" style="margin-top: 32px;">
      <h5>Activities Logs</h5>
      <table class="table table-bordered table-hover">
        <tbody>
          <tr>
            <th>Sr</th>
            <th>User</th>
            <th>Amount</th>
            <th>Updated Date</th>
          </tr>
          <tr v-for="(item, index) in pricePlan.price_plan_activities" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td>
              {{
                item.user && `${item.user.first_name} ${item.user.last_name}`
              }}
            </td>
            <td>{{ parseFloat(item.amount) }}</td>
            <td>{{ moment(item.updated_at).format('MMM DD, Y hh:mm a') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
// import Multiselect from 'vue-multiselect';
import axios from "axios";
import moment from "moment";
export default {
  props: ["action", "formData", "pageNumber"],
  data: function () {
    return {
      amount: 0,
      pricePlan: {},
      flag: true,
      isMiniLoading: false,
    };
  },

  computed: {
    getPlan: function () {
      this.getPricePlan();
    },
  },
  methods: {
    getPricePlan: function () {
      this.amount = 0;
      this.pricePlan = {};
      axios
        .get("admin/organization/price-plan/" + this.formData.org_id)
        .then((response) => {
          const { data } = response.data;
          this.amount = parseFloat(data.amount);
          this.pricePlan = data;
        });
    },
    savePrice: async function () {
      try {
        if(this.amount == parseFloat(this.pricePlan.amount) || !this.amount || this.amount <= 0){
          return this.$toast.error("Enter valid Amount");
        }

        this.isMiniLoading = true;
        let url = Object(this.pricePlan).hasOwnProperty("id")
          ? `admin/organization/price-plan/${this.formData.org_id}/${this.pricePlan.id}`
          : `admin/organization/price-plan/${this.formData.org_id}`;
        const response = await axios.post(url, { amount: this.amount });
        if (response.data.status) {
          this.getPricePlan();
          this.$toast.success("Amount Saved");
        }
        this.isMiniLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    cancel() {
      (amount = 0), (pricePlan = {});
      this.flag = true;
    },
    moment: function (date = null) {
      date = date || new Date();
      return moment(date);
    },
  },
};
</script>
